import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { Languages } from "lucide-react";
import { LANG, switchLanguage, withLang } from "@/lib/i18n/lang";

export function LanguageSwitch({ className = "", testId = "lang-switch" }) {
  return (
    <div translate="no" role="group" aria-label="Language" data-testid={testId}
      className={`inline-flex shrink-0 items-center rounded-full border border-slate-200 bg-white/80 p-0.5 text-xs font-semibold ${className}`}>
      <Languages className="ml-1.5 mr-0.5 h-3.5 w-3.5 text-[#165a71]" aria-hidden />
      {[["en", "EN"], ["es", "ES"]].map(([code, label]) => (
        <button key={code} type="button" onClick={() => code !== LANG && switchLanguage(code)} aria-pressed={code === LANG}
          className={`rounded-full px-2.5 py-1 transition-colors ${code === LANG ? "bg-[#165a71] text-white" : "text-[#252A34]/70 hover:text-[#071b22]"}`}
          data-testid={`${testId}-${code}`}>{label}</button>
      ))}
    </div>
  );
}

export function LangAlternates() {
  const { pathname } = useLocation();
  const origin = window.location.origin;
  return (
    <Helmet htmlAttributes={{ lang: LANG }}>
      <link rel="alternate" hrefLang="en" href={origin + pathname} />
      <link rel="alternate" hrefLang="es" href={origin + withLang("es", pathname)} />
      <link rel="alternate" hrefLang="x-default" href={origin + pathname} />
      <meta property="og:image" content={`${origin}/brand/og-image.jpg`} />
      <meta property="og:url" content={origin + withLang(LANG, pathname)} />
    </Helmet>
  );
}
